<template>
  <router-view />
  <page-loader></page-loader>
  <idle-warning-modal></idle-warning-modal>
</template>

<script>
import PageLoader from "@/components/PageLoader";
import IdleWarningModal from "@/components/IdleWarningModal";

export default {
  components: {
    PageLoader,
    IdleWarningModal,
  },
  beforeMount() {
    this.$gates.app(this).$global.app(this);
  },
  mounted() {
    this.$axios.defaults.headers.common["Authorization"] =
      "Bearer " + this.$store.state.token;
    this.$global.translatables(
      this.$store.state.translatables
        ? this.$store.state.translatables.locale
        : "",
      () => {
        this.$moment.locale(this.$store.state.translatables.locale);
      },
    );
    if (this.$store.state.token) {
      this.$idleTimer.start();
    }
  },
  watch: {
    "$store.state.token"(token) {
      if (token) {
        this.$idleTimer.start();
      } else {
        this.$idleTimer.stop();
      }
    },
  },
};
</script>
